import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::deleteMethod
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/invoicing-category-delete/{invoicingCategory}'
*/
export const deleteMethod = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/api/invoicing-category/invoicing-category-delete/{invoicingCategory}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::deleteMethod
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/invoicing-category-delete/{invoicingCategory}'
*/
deleteMethod.url = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoicingCategory: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoicingCategory: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoicingCategory: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoicingCategory: typeof args.invoicingCategory === 'object'
        ? args.invoicingCategory.id
        : args.invoicingCategory,
    }

    return deleteMethod.definition.url
            .replace('{invoicingCategory}', parsedArgs.invoicingCategory.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::deleteMethod
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/invoicing-category-delete/{invoicingCategory}'
*/
deleteMethod.delete = (args: { invoicingCategory: string | number | { id: string | number } } | [invoicingCategory: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::undo
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/undo-delete/{id}'
*/
export const undo = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

undo.definition = {
    methods: ["get","head"],
    url: '/api/invoicing-category/undo-delete/{id}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::undo
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/undo-delete/{id}'
*/
undo.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return undo.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::undo
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/undo-delete/{id}'
*/
undo.get = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: undo.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\InvoicingCategory\DeleteInvoicingCategoryController::undo
* @see app/Http/Controllers/InvoicingCategory/DeleteInvoicingCategoryController.php
* @route '/api/invoicing-category/undo-delete/{id}'
*/
undo.head = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: undo.url(args, options),
    method: 'head',
})

const DeleteInvoicingCategoryController = { deleteMethod, undo, delete: deleteMethod }

export default DeleteInvoicingCategoryController